import * as C from "react";
import { validateDate as e } from "./validateDate.mjs";
import { useLocalizationContext as k } from "./useUtils.mjs";
const I = ({
  shouldDisableDate: r,
  shouldDisableMonth: o,
  shouldDisableYear: t,
  minDate: p,
  maxDate: c,
  disableFuture: a,
  disablePast: f,
  timezone: m
}) => {
  const n = k();
  return C.useCallback((v) => e({
    adapter: n,
    value: v,
    props: {
      shouldDisableDate: r,
      shouldDisableMonth: o,
      shouldDisableYear: t,
      minDate: p,
      maxDate: c,
      disableFuture: a,
      disablePast: f,
      timezone: m
    }
  }) !== null, [n, r, o, t, p, c, a, f, m]);
};
export {
  I as useIsDateDisabled
};
//# sourceMappingURL=useIsDateDisabled.mjs.map
